<div class="my-2">
	<app-checkbox
		type="clear"
		[ngModel]="firstPageFooter"
		(ngModelChange)="onFirstPageFooterChange($event)"
		>First page</app-checkbox
	>
</div>

<div class="my-2">
	<app-checkbox
		type="clear"
		[ngModel]="allPagesFooter"
		(ngModelChange)="onAllPagesFooterChange($event)"
		>All other pages</app-checkbox
	>
</div>
